import React, { useContext, useEffect, useRef, useState } from 'react';
import { WelletContext } from '../../../context/WelletContext';

import { useDispatch, useSelector } from 'react-redux';
import { setCanRefresh } from '../../../actions/appActions';
import { setReservation } from '../../../actions/reservationActions';
import { useTranslation } from 'react-i18next';
import { getQueryString } from '../../../helpers/url';
import { CircleSpinner } from 'react-spinners-kit';
import { formatDateTime, getDateFromOffset } from '../../../helpers/dates';
import { format } from 'date-fns';
import Header from '../../../components/Common/Header/Header';
import { Navigation, Pagination } from 'swiper/modules';

import styles from './VenueDetail.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

import './styles.css';
import { formatMoney } from '../../../helpers/format';
import ContentApp from '../../../components/ContentApp';
import Line from '../../../components/Common/Line/Line';
import ProductModal from '../../../components/Common/ProductModal/ProductModal';
import ShareIcon from '../../../components/icons/ShareIcon';
import Qr from '../../../components/Common/Qr/Qr';
import BottomSheet from '../../../components/BottomSheet/BottomSheet';
import ButtonCard from '../../../components/ButtonCard/ButtonCard';
import millify from 'millify';
import { getCityCountry } from '../../../helpers/text';
import RetinaImg from '../../../components/RetinaImg/RetinaImg';
import ChevronIconBig from '../../../components/icons/chevronIconBig';

const VenueDetail = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const reservation = useSelector((state) => state.reservation);
  const showId = getQueryString('showId');
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(null);
  const [today, setToday] = useState(null);
  const [openQr, setOpenQr] = useState(false);
  const company = useSelector((state) => state.app);
  const qrLink = useSelector((state) => state.associates.user.qrUserUrl);
  const swiperRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const currency = useSelector((state) => state.currency.default);
  const [overlayHeight, setOverlayHeight] = useState(0);

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: company.name,
          url: qrLink,
        });
      } else {
        console.warn('Web Share API not supported in this browser.');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: showId,
          lang: language,
          details: true,
          reservationType: 'RESTAURANT',
          images: true,
          videos: true,
          IsFeature: true,
          includeStats: true,
        },
      });

      setShow(result.data);

      let todayDate = new Date(getDateFromOffset(result.data.utcOffset));

      const minutes = todayDate.getMinutes();
      todayDate.setMinutes(minutes === 0 ? minutes : minutes + (15 - (minutes % 15)), 0, 0);

      setToday(todayDate);

      if (
        !reservation.date ||
        formatDateTime(reservation.date, reservation.performance) < todayDate
      ) {
        dispatch(
          setReservation({
            ...reservation,
            date: format(todayDate, 'yyyy-MM-dd'),
          }),
        );
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleReferralLink = () => {
    history.push(
      '/referral-link?showId=' +
        showId +
        '&link=' +
        show.link +
        '&showName=' +
        show.name +
        '&showCity=' +
        getCityCountry(show.city.nameLong) +
        '&commissionPercentage=' +
        show.commission,
    );
  };

  const onBookingClick = () => {
    if (show.purchaseTemplate === 'TRANSFER') {
      history.push('/transfer-selector?showId=' + showId);
    } else {
      history.push('/calendar-ticket-selector?showId=' + showId);
    }
  };

  const getLocation = () => {
    const address = show.address.split(',').map((str) => str.trim());
    const textCity = show.city.nameLong.split(',').map((str) => str.trim());
    let secondLine = show.postalCode;

    if (address.length > 1) secondLine = `${address[1]}, ${secondLine}`;

    return (
      <div>
        <div>{address[0]}</div>
        <div>{secondLine}</div>
        <div>{`${textCity[0]}, ${textCity[1]}`}</div>
        <div>{textCity[2]}</div>
        {/* {show.latitude && show.longitude && (
          <div className={styles.locationMap}>
            {!mapLoaded && (
              <Skeleton
                variant='rectangular'
                sx={{
                  bgcolor: 'grey.900',
                  width: '100%',
                  height: '100%',
                  borderRadius: '.4rem',
                }}
              />
            )}

            <img
              className={`${mapLoaded ? '' : 'd-none'}`}
              src={`https://tile1.gosurmaps.com/styles/gosur/static/${show.longitude},${show.latitude},16/400x400@2x.png`}
              onLoad={() => setMapLoaded(true)}
              alt='map'
            />
            <div className={`${styles.marker} ${mapLoaded ? '' : 'd-none'}`}>
              <MarkerIcon size={32} color={'#ea4335'} />
            </div>
          </div>
        )} */}
      </div>
    );
  };

  const headerHtml = () => {
    return (
      <div>
        <div className='text-center'>
          <h1 className='font-large fw-700 m-0'>{show.name}</h1>
          <div className='text-secondary font-tiny'>{getCityCountry(show.city.nameLong)}</div>
          {show.commission && show.commission > 0 && (
            <div className='text-tertiary font-tiny fw-600 mt-2'>
              {t('earnUpTo', {
                commission: show.commission,
              })}
            </div>
          )}

          {show.stats?.avgCommissionPerSale > 0 && (
            <div
              className='text-primary font-tiny fw-600 mt-1'
              dangerouslySetInnerHTML={{
                __html: t('avgCommissionPerSale', {
                  amount: formatMoney(
                    show.stats.avgCommissionPerSale,
                    {
                      currencySymbol: currency.symbol,
                    },
                    true,
                  ),
                }),
              }}
            />
          )}
        </div>
        <div className='row mt-3'>
          <div className='col-6 pr-1'>
            <ButtonCard
              title={t('reservationLink')}
              description={t('reservationLinkDescription')}
              onClick={() => handleReferralLink()}
            />
          </div>
          <div className='col-6 pl-1'>
            <ButtonCard
              title={t('bookNow')}
              description={t('bookNowDescription')}
              onClick={() => onBookingClick()}
            />
          </div>
        </div>
        <div className='mt-3'>
          <ButtonCard
            title={t('promoteOnYourSocialNetworks')}
            description={t('promoteOnYourSocialNetworksDescription')}
            onClick={() => history.push('/campaigns-feed-by-show?showId=' + showId)}
          />
        </div>
        {show.stats?.minProductPrice && show.stats?.maxProductPrice ? (
          <div className='text-center font-tiny fw-500 mt-2'>
            {t('priceFromTo', {
              minPrice: currency.symbol + millify(show.stats.minProductPrice),
              maxPrice: currency.symbol + millify(show.stats.maxProductPrice),
              currency: currency.shortForm,
            })}
          </div>
        ) : null}
      </div>
    );
  };

  const contentHtml = () => {
    return (
      <div style={{ paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))' }}>
        <div className={styles.hideContentIphone}></div>
        {show.stats?.qtyAmbassadorDeals > 0 && (
          <div
            className='text-center py-2 px-3'
            style={{
              border: '1px solid #1D9BF0',
              borderRadius: '5px',
              backgroundColor: 'var(--color-dark-gray)',
              marginTop: 'calc(0.5rem - (env(safe-area-inset-top)) * 0.5)',
            }}
          >
            <div
              className='font-tiny text-primary'
              dangerouslySetInnerHTML={{
                __html:
                  t('ambassadorsQty', { count: show.stats?.qtyAmbassadorDeals }) +
                  ' ' +
                  t('ambassadorsQty2', { qty: show.stats?.qtyReservations }),
              }}
            />
          </div>
        )}

        {show.shortDescription && show.shortDescription.length > 0 && (
          <div className='mt-4'>
            <div className='text-primary font-tiny fw-700'>{t('activityDetails')}</div>
            <div
              className='text-lighter-gray mt-1 font-tiny'
              dangerouslySetInnerHTML={{ __html: show.shortDescription }}
            />
          </div>
        )}

        <div className='mt-4'>
          <div className='text-primary font-tiny fw-700'>{t('operatorInfo')}</div>
          <div className='text-lighter-gray mt-1 font-tiny'>
            <div>{show.organization.name}</div>
            <div>{show.organization.legalName}</div>
            {show.organization.operatorNumber && (
              <div>
                {t('registrationNumber')}: {show.organization.operatorNumber}
              </div>
            )}
          </div>
          <div className='text-secondary font-extra-small mt-3'>{t('operatorCertification')}</div>
        </div>

        <div className='mt-4'>
          <div className='text-primary font-tiny fw-700'>{t('location')}</div>
          <div className='text-lighter-gray mt-1 font-tiny'>{getLocation()}</div>
        </div>
        <div
          className={`${styles.webSiteContainer} p-3 mt-4`}
          onClick={() =>
            window.open(show.externalWebsiteUrl ? show.externalWebsiteUrl : show.link, '_blank')
          }
        >
          <div className='row'>
            <div className='col-auto my-auto'>
              <RetinaImg
                src='../../images/WebIcon.png'
                alt='Avatar de usuario'
                width={24}
                height={24}
              />
            </div>
            <div className='col text-tertiary px-0'>
              <div className='font-small fw-600'>{t('visitOfficialWebsite')}</div>
              <div className='font-extra-small'>{t('visitOfficialWebsiteDescription')}</div>
            </div>
            <div className='col-auto my-auto'>
              <ChevronIconBig fillColor='var(--color-primary)' size={24} />
            </div>
          </div>
        </div>
        <div className='text-primary font-tiny text-center mt-3'>
          {t('trackEarningsInYourDashboard')}
        </div>
      </div>
    );
  };

  useEffect(() => {
    dispatch(setCanRefresh(false));
    getShow();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      dispatch(setCanRefresh(true));
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header pathName={`/restaurant-list`} absolute={true} />
          <ContentApp classes='p-0 overflow-hidden'>
            <div className={styles.pageHeader}>
              <div className={`${styles.pageSection} ${styles.header}`}>
                <div className={styles.background}>
                  <Swiper
                    ref={swiperRef}
                    className={`swiper-show ${styles.swiperContainer} custom-swiper `}
                    pagination={true}
                    modules={[Navigation, Pagination]}
                    lazy={true}
                    style={{
                      '--swiper-pagination-top': overlayHeight + 'px',
                      '--swiper-pagination-bottom': 'none',
                      '--swiper-pagination-color': '#fff',
                      '--swiper-pagination-bullet-inactive-color': '#999999',
                      '--swiper-pagination-bullet-inactive-opacity': '1',
                      '--swiper-pagination-bullet-size': '7px',
                      '--swiper-pagination-bullet-horizontal-gap': '6px',
                    }}
                  >
                    {show?.videos &&
                      show.videos.map((video, index) => (
                        <SwiperSlide key={`video-${index}`}>
                          <div className={styles.overlay}>
                            <video
                              webkit-playsinline='true'
                              x5-playsinline='true'
                              playsInline
                              autoPlay
                              loop
                              muted
                              src={video.videoUrl}
                              alt='media'
                              style={{ width: '100%' }}
                            />
                          </div>
                        </SwiperSlide>
                      ))}

                    <SwiperSlide>
                      <div className={styles.overlay}>
                        <img
                          src={!isMobile ? show.imageUrl : show.bannerImageUrl}
                          alt={show.name}
                        />
                      </div>
                    </SwiperSlide>

                    {show?.images &&
                      show.images.map((image, index) => (
                        <SwiperSlide key={`image-${index}`}>
                          <div className={styles.overlay}>
                            <img src={image.imageUrl} alt={show.name} />
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            </div>

            <BottomSheet
              header={headerHtml()}
              content={contentHtml()}
              onSetHeight={(height) => setOverlayHeight(window.innerHeight - height - 30)}
            />

            <ProductModal
              animationClass='fade-up-down'
              open={openQr}
              hasBackground
              onClose={() => setOpenQr(false)}
              fullScreen
              backIcon
              customStyle={{
                backgroundColor: 'transparent',
                border: 'none',
              }}
            >
              <>
                <ContentApp>
                  <div className='card align-items-center p-3'>
                    <div className={styles.imageContainer}>
                      <img src={show.logoUrl} alt='logo' />
                    </div>
                    <div className='font-large fw-semibold my-2 text-center'>{show.name}</div>
                    <Line color='#353535' className='w-100 my-4' />

                    <Qr
                      qrUrl={show.link}
                      logo={show.logoUrl}
                      welletContext={welletContext}
                      logoBorder='ROUNDED'
                    />
                    <div className='font-large text-center fw-semibold m-3'>
                      {t('scanToMakeReservation')}
                    </div>
                  </div>

                  <div
                    className='text-center text-secondary font-small mt-3'
                    onClick={() => handleShare()}
                  >
                    {t('shareLinkToBook')}
                    <ShareIcon size={25} color={'#7e7e7e'} styles={{ marginLeft: '4px' }} />
                  </div>
                </ContentApp>
              </>
            </ProductModal>
          </ContentApp>
        </>
      )}
    </>
  );
};

export default VenueDetail;
